import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { Provider } from 'react-redux'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/storage'
import 'firebase/firestore'
import { Collection } from 'constants/index'
import { FIREBASE_CONFIG } from 'config/firebase-config'
import authSlice from 'store/auth'
import store from 'store'
import './index.css'

firebase.initializeApp(FIREBASE_CONFIG)
export const FirestoreDatabase = firebase.firestore()
export const storage = firebase.storage()
export const storageRef = storage.ref('images')
store.dispatch(authSlice.actions.setProgress(true))

firebase.auth().onAuthStateChanged(async (fireUser) => {
  if (fireUser) {
    const user = {
      id: fireUser.uid,
      email: fireUser.email
    }
    const snapshot = await firebase.firestore().collection(Collection.USERS).doc(user.id).get()
    store.dispatch(authSlice.actions.setUser({ ...user, ...snapshot.data() }))
    store.dispatch(authSlice.actions.setAuthenticated(true))
    store.dispatch(authSlice.actions.setProgress(false))
  } else {
    store.dispatch(authSlice.actions.setUser(null))
    store.dispatch(authSlice.actions.setAuthenticated(false))
    store.dispatch(authSlice.actions.setProgress(false))
  }
})

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
)
